import type { CollaborationHighlightContext } from '@/stores/collaborationHighlightStore';

export function canShowHighlightOnRoute(
  eventContext: CollaborationHighlightContext,
  routeContext: CollaborationHighlightContext
): boolean {
  if (routeContext === 'parse_flow') return eventContext === 'parse_flow';
  if (routeContext === 'project_page') return eventContext === 'project_page';
  if (routeContext === 'canvas')
    return eventContext === 'project_page' || eventContext === 'canvas';
  return false;
}

export function normalizeHighlightContextForRoute(
  _eventContext: CollaborationHighlightContext,
  routeContext: CollaborationHighlightContext
): CollaborationHighlightContext {
  return routeContext;
}

export function resolveCanvasRouteProjectId(
  pathname: string,
  fallback: string | null
): string | null {
  const canvasMatch = pathname.match(/^\/project\/([^/]+)\/canvas\/?$/u);
  if (canvasMatch?.[1]) return canvasMatch[1];
  const projectMatch = pathname.match(/^\/project\/([^/]+)$/u);
  return projectMatch?.[1] ?? fallback;
}
